import React from 'react'
import { Route, useRouteMatch, useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

// import components
import PendingPrescriptionCases from "../../../PendingPrescriptionCases/PendingPrescriptionCases";
import PhysicianDashboard from "../../../Dashboard/PhysicianDashboard/PhysicianDashboard";
import CaseView from '../../../CaseView'
import OneClickPrescribe from '../../../OneClickPrescribe'
import MyAvailability from "../../../schedule/MyAvailability";
import RxChangeRequests from "../../../RxChangeRequests/RxChangeRequests";
import AdditionalInfoRequired from "../../../AdditionalInfoRequired/AdditionalInfoRequired";
import OtherPhysiciansCases from "../../../OtherPhysiciansCases";
import CaseQueue from "../../../CaseQueue"
import Messages from "../../../Messages";
import Templates from "../../../Templates";
import ProfileView from "../../../Account/ProfileView";
import CompletedConsults from "../../../CompletedConsults/CompletedConsults.container";
import ConsultCompletedNoRx from "../../../ConsultCompletedNoRx/ConsultCompletedNoRx.container";
import Articles from "../../../Articles";
import ArticleView from "../../../Articles/components/ArticleView";
import CaseTicket from "../../../CaseTicket/CaseTicket";
import AllCases from "../../../Cases/AllCases";
import SyncCases from "../../../Cases/SyncCases";
import Reports from "../../../Reports"
import InternalRxRequests from "../../../InternalRxRequests";
import IncompleteCases from "../../../IncompleteCases"
import Referrals from "../../../Referrals"
import HeisenbergRequests from "../../../HeisenbergRequests"
import History from "../../../History"
import Reassigned from '../../../Reassigned/Reassigned';

import { PhysicianTagEnum, ConfigKeyEnum } from "../../../../types/enums"
import { BackButton } from "./styles"

export const AppRouter = ({
    loggedInPhysicianDetails
}) => {
    const { path } = useRouteMatch();
    const history = useHistory();

    const physicianTags = loggedInPhysicianDetails?.tags?.map(tag => tag.toLowerCase())
    const physicianNeedsCasesReviewed = physicianTags?.includes(PhysicianTagEnum.NEEDS_REVIEW)
    const isReviewingPhysician = physicianTags?.includes(PhysicianTagEnum.REVIEWER)
    const isLeadPhysician = physicianTags?.includes(PhysicianTagEnum.LEAD_PHYSICIAN)
    const providerHasPinSet = loggedInPhysicianDetails?.pinSet
    const oneClickPrescribeEnabled = useSelector(({ configs }) => configs.configs[ConfigKeyEnum.ONE_CLICK_PRESCRIBE_ENABLED]);
    
    return (
        <>
            <BackButton onClick={() => history.goBack()}>
                <ArrowLeftOutlined />
                Back
            </BackButton>
            <div className="route-outlet">
            <Route exact path={path}>
                <PhysicianDashboard />
            </Route>
            <Route
                path={`${path}/physician/myaccount`}
            >
                <ProfileView />
            </Route>
            <Route
                path={`${path}/physician/case-queue`}
            >
                <CaseQueue />
            </Route>
            <Route
                path={`${path}/physician/sync-cases`}
            >
                <SyncCases />
            </Route>
            <Route
                path={`${path}/physician/caselist`}
            >
                <PendingPrescriptionCases />
            </Route>
            <Route
                path={`${path}/physician/cases`}
            >
                <AllCases title='Cases' type='cases' />
            </Route>
            <Route
                path={`${path}/physician/reassigned-cases`}
            >
                <Reassigned />
            </Route>
            <Route
                path={`${path}/physician/caseview/:id`}
                render={({ match, location }) => (
                    <CaseView 
                        statusUpdateRequired 
                        physicianDetails={loggedInPhysicianDetails}
                        caseId={match.params.id}
                        requestId={new URLSearchParams(location.search).get('requestId')}
                    />
                )}
            />
            <Route
                path={`${path}/physician/rx-requests`}
            >
                <HeisenbergRequests provider={loggedInPhysicianDetails} />
            </Route>
            <Route
                path={`${path}/physician/additional-info-required`}
            >
                <AdditionalInfoRequired />
            </Route>
            <Route
                path={`${path}/physician/other-physicians-cases`}
            >
                <OtherPhysiciansCases />
            </Route>
            <Route
                path={`${path}/physician/history`}
            >
                <History />
            </Route>
            <Route
                path={`${path}/physician/consultedcase`}
            >
                <CompletedConsults
                    title={"Completed Consults"}
                    type={"consult complete"}
                />
            </Route>
            <Route
                path={`${path}/physician/consultedcase-noRX`}
            >
                <ConsultCompletedNoRx
                    title={"Consult Complete, No Rx"}
                    type={"consult complete no rx"}
                />
            </Route>
            <Route
                path={`${path}/physician/availability`}
            >
                <MyAvailability />
            </Route>

            <Route
                path={`${path}/physician/updateprescribe`}
            >
                <RxChangeRequests />
            </Route>

            <Route path={`${path}/physician/rx-change-requests`}>
                <InternalRxRequests />
            </Route>

            {
                (physicianNeedsCasesReviewed || isReviewingPhysician) &&
                <Route path={`${path}/physician/referrals`}>
                    <Referrals />
                </Route>
            }

            <Route path={`${path}/physician/incomplete-cases`}>
                <IncompleteCases />
            </Route>

            <Route
                path={`${path}/physician/messages`}
            >
                <Messages />
            </Route>

            <Route
                path={`${path}/physician/templates`}
            >
                <Templates isLeadPhysician={isLeadPhysician} />
            </Route>

            <Route
                path={`${path}/physician/case-tickets`}
            >
                <CaseTicket />
            </Route>
            <Route
                path={`${path}/physician/articles`}
            >
                <Articles />
            </Route>
            <Route
                path={`${path}/physician/article-view/:id`}
            >
                <ArticleView />
            </Route>
            <Route
                path={`${path}/physician/reports`}>
                <Reports />
            </Route>
            { isLeadPhysician && oneClickPrescribeEnabled && <Route
                path={`${path}/physician/one-click-prescribe`}
                >
                    <OneClickPrescribe providerHasPinSet={providerHasPinSet}/>
                </Route>
            }
            </div>
        </>

    )
}